module.exports = __webpack_public_path__ + "img/elasticbitcoin-REBASE-LAG-FACTOR.b41a33b1.svg";